export default __webpack_public_path__ + "static/media/background-left.36db08c5.png";